import React from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import Footer from "../layouts/footer";

import ContactPageContainer from "../containers/contact";
import ScrollToTop from "../components/scroll-to-top";


const ContactPage = () => {
    return (
        <React.Fragment>
            <Layout>
            
                <div className="wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                   
                        <ContactPageContainer />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ContactPage;
